import {
  BaseEntity,
  JsonApiProperty,
  JsonApiRelationship,
  JsonApiResource,
} from '../jsonapi-provider';
import Supply from './supply';

@JsonApiResource({
  type: 'cycle-menu-supply',
})
export default class CycleMenuSupply extends BaseEntity {
  @JsonApiProperty({ resolver: Number }) price = 0.0;

  @JsonApiRelationship('supply') supply = new Supply();

  constructor(id?: string, price = 0.0, supply = new Supply()) {
    super();
    this.id = id;
    this.price = price;
    this.supply = supply;
  }
}
